import React, { useEffect } from 'react'

import { useBranding } from '../hooks'

function InstanceBrandingInjector() {
  const branding = useBranding()

  useEffect(() => {
    // Inject custom CSS
    if (branding?.customCss) {
      console.log('💄 Injecting Instance Branding CSS')
      const existingStyle = document.getElementById('instance-branding-css')
      if (existingStyle) {
        existingStyle.remove()
      }

      const style = document.createElement('style')
      style.id = 'instance-branding-css'
      style.type = 'text/css'
      style.innerHTML = branding.customCss
      document.head.appendChild(style)
    }

    // Inject custom JavaScript (safely)
    if (branding?.customJs) {
      console.log('⚡ Injecting Instance Branding JavaScript')
      try {
        // Create a script element and execute it
        const script = document.createElement('script')
        script.id = 'instance-branding-js'
        script.type = 'text/javascript'
        script.innerHTML = branding.customJs

        // Remove existing script if it exists
        const existingScript = document.getElementById('instance-branding-js')
        if (existingScript) {
          existingScript.remove()
        }

        document.head.appendChild(script)
      } catch (error) {
        console.error('❌ Error executing custom JavaScript:', error)
      }
    }

    // Inject analytics code
    if (branding?.analyticsCode) {
      console.log('📊 Injecting Analytics Code')
      const existingAnalytics = document.getElementById('instance-analytics')
      if (existingAnalytics) {
        existingAnalytics.remove()
      }

      const analyticsDiv = document.createElement('div')
      analyticsDiv.id = 'instance-analytics'
      analyticsDiv.innerHTML = branding.analyticsCode
      document.head.appendChild(analyticsDiv)
    }

    // Cleanup function
    return () => {
      // Remove injected styles and scripts when component unmounts or branding changes
      const customStyle = document.getElementById('instance-branding-css')
      const customScript = document.getElementById('instance-branding-js')
      const analytics = document.getElementById('instance-analytics')

      if (customStyle) customStyle.remove()
      if (customScript) customScript.remove()
      if (analytics) analytics.remove()
    }
  }, [branding?.customCss, branding?.customJs, branding?.analyticsCode])

  // This component doesn't render anything
  return null
}

export default InstanceBrandingInjector
